var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowWhiteUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.06838 7.06899C8.95267 7.18471 8.77306 7.19756 8.64315 7.10757L8.59698 7.06899L5.16602 3.63796L1.73505 7.06899C1.61934 7.18471 1.43972 7.19756 1.30981 7.10757L1.26365 7.06899C1.14794 6.95328 1.13508 6.77367 1.22508 6.64376L1.26365 6.59759L4.93031 2.93092C5.04602 2.81521 5.22564 2.80236 5.35555 2.89235L5.40172 2.93092L9.06838 6.59759C9.19856 6.72777 9.19856 6.93882 9.06838 7.06899Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.8
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowWhiteUp);
export default __webpack_public_path__ + "static/media/arrow-white-up.6d1b861b.svg";
export { ForwardRef as ReactComponent };